import { AnimatedSpinner } from '../../../components/AnimatedSpinner'
import { Modal } from '../Modal/Modal'

interface IDeleteModalProps {
  open: boolean
  isLoading?: boolean
  onClose: () => void
  onDelete: () => void
}

export function DeleteModal({
  open,
  onClose,
  onDelete,
  isLoading,
}: IDeleteModalProps) {
  return (
    <Modal
      title="Delete Item"
      open={open}
      onClose={isLoading ? () => {} : onClose}
    >
      <p className="text-white py-4 px-6">
        Are you sure you want to delete this item?
      </p>
      <div className="flex justify-end gap-4 border-t border-white/10 py-4 px-6">
        <button
          onClick={onClose}
          disabled={isLoading}
          className="btn btn-secondary hover:bg-red-200 transition-bg"
        >
          Cancel
        </button>
        <button
          onClick={onDelete}
          className="btn bg-red-600 text-white rounded-md hover:bg-red-700"
          disabled={isLoading}
        >
          {isLoading && <AnimatedSpinner className="mr-2" />}
          Delete
        </button>
      </div>
    </Modal>
  )
}
